(function () {
  'use strict';

  // ── Money formatter ─────────────────────────────────────────────────────────
  function formatMoney(cents) {
    var fmt = window.brtMoneyFormat || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{amount\}\}/g, val)
      .replace(/\{\{amount_no_decimals\}\}/g, Math.round(cents / 100))
      .replace(/\{\{amount_with_comma_separator\}\}/g, val.replace('.', ','))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, Math.round(cents / 100));
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── Cart helpers ─────────────────────────────────────────────────────────────
  function addToCart(variantId, qty, cb, isPreorder) {
    var payload = {
      id: Number(variantId),
      quantity: qty || 1
    };

    if (isPreorder) {
      payload.properties = {
        'Order Type': 'Pre-order'
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function (item) {
        refreshCartCount();
        cb(null, item);
      })
      .catch(function (err) {
        cb(err);
      });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Dawn cart count bubble: first aria-hidden span holds the number
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          var hidden = el.querySelector('[aria-hidden]');
          if (hidden) hidden.textContent = cart.item_count;
          var visible = el.querySelector('.visually-hidden');
          if (visible) visible.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  // ── Success toast ─────────────────────────────────────────────────────────────
  var TOAST_ID = 'brt-qa-toast';

  function showToast(item) {
    var toast = document.getElementById(TOAST_ID);
    if (!toast) {
      toast = document.createElement('div');
      toast.id = TOAST_ID;
      document.body.appendChild(toast);
    }
    var img = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" class="brt-toast-img">'
      : '<div class="brt-toast-img brt-toast-img--empty"></div>';
    toast.innerHTML =
      '<div class="brt-toast-inner">' +
        img +
        '<div class="brt-toast-info">' +
          '<div class="brt-toast-title">' + esc(item.title) + '</div>' +
          '<div class="brt-toast-sub">Added to cart ✓</div>' +
        '</div>' +
        '<a href="/cart" class="brt-toast-view">View cart →</a>' +
      '</div>';
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
  }

  // ── Variant picker modal ──────────────────────────────────────────────────────
  var MODAL_ID = 'brt-qa-modal';
  var scrollPos = 0;

  function ensureModal() {
    if (document.getElementById(MODAL_ID)) return;
    var el = document.createElement('div');
    el.id = MODAL_ID;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Quick Add');
    el.innerHTML =
      '<div class="brt-qa-backdrop"></div>' +
      '<div class="brt-qa-sheet">' +
        '<button class="brt-qa-close" type="button" aria-label="Close">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">' +
            '<path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<div class="brt-qa-body"></div>' +
        '<div class="brt-qa-footer">' +
          '<button class="brt-qa-atc" type="button">Add to cart</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    el.querySelector('.brt-qa-backdrop').addEventListener('click', closeModal);
    el.querySelector('.brt-qa-close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

    function openModal(product, isPreorder) {
      ensureModal();
      var modal = document.getElementById(MODAL_ID);
      var body = modal.querySelector('.brt-qa-body');
      var atcBtn = modal.querySelector('.brt-qa-atc');

      modal.dataset.preorder = isPreorder ? 'true' : 'false';

      atcBtn.textContent = isPreorder ? 'Pre-order' : 'Add to cart';
      atcBtn.disabled = false;
      atcBtn.dataset.variantId = '';
      atcBtn.onclick = null;

      body.innerHTML = buildBody(product);

      body.querySelectorAll('.brt-qa-opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.closest('.brt-qa-opt-group').querySelectorAll('.brt-qa-opt-btn').forEach(function (b) {
            b.classList.remove('is-sel');
          });

          btn.classList.add('is-sel');
          syncVariant(product, modal);
        });
      });

      syncVariant(product, modal);

      modal.classList.add('is-open');
      scrollPos = window.pageYOffset;
      document.body.style.top = '-' + scrollPos + 'px';
      document.body.classList.add('brt-scroll-lock', 'brt-overlay-open');

      atcBtn.onclick = function () {
        var vid = atcBtn.dataset.variantId;
        if (!vid || atcBtn.disabled) return;

        atcBtn.disabled = true;
        atcBtn.textContent = isPreorder ? 'Adding preorder…' : 'Adding…';

       addToCart(vid, 1, function (err, item) {
          if (err) {
            atcBtn.disabled = false;
            atcBtn.textContent = isPreorder ? 'Pre-order' : 'Add to cart';
            return;
          }

          closeModal();
          showToast(item);
        }, isPreorder);
              };
    }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.classList.remove('is-open');
    document.body.classList.remove('brt-scroll-lock', 'brt-overlay-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollPos);
  }

  function buildBody(product) {
    var img = product.featured_image
      ? '<img src="' + esc(product.featured_image) + '" alt="' + esc(product.title) + '" class="brt-qa-img">'
      : '';
    var price = product.variants.length ? formatMoney(product.variants[0].price) : '';

    var optHtml = '';
    // Shopify AJAX API can return options as strings OR as {name, position, values} objects
    var firstOpt = product.options[0];
    var firstOptName = (firstOpt && typeof firstOpt === 'object') ? firstOpt.name : firstOpt;
    var hasRealOptions = !(product.options.length === 1 && firstOptName === 'Title');
    if (hasRealOptions) {
      product.options.forEach(function (optObj, idx) {
        var displayName = (optObj && typeof optObj === 'object') ? optObj.name : optObj;
        var seen = {};
        var values = product.variants.map(function (v) { return v.options[idx]; }).filter(function (v) {
          return seen[v] ? false : (seen[v] = true);
        });
        optHtml +=
          '<div class="brt-qa-opt-group" data-opt-idx="' + idx + '">' +
            '<div class="brt-qa-opt-label">' + esc(displayName) + '</div>' +
            '<div class="brt-qa-opt-btns">' +
              values.map(function (v, i) {
                return '<button class="brt-qa-opt-btn' + (i === 0 ? ' is-sel' : '') + '" data-val="' + esc(v) + '" type="button">' + esc(v) + '</button>';
              }).join('') +
            '</div>' +
          '</div>';
      });
    }

    return (
      '<div class="brt-qa-product">' +
        '<div class="brt-qa-product-img">' + img + '</div>' +
        '<div class="brt-qa-product-meta">' +
          '<div class="brt-qa-name">' + esc(product.title) + '</div>' +
          '<div class="brt-qa-price" data-price>' + price + '</div>' +
        '</div>' +
      '</div>' +
      optHtml
    );
  }

  function syncVariant(product, modal) {
    var groups = modal.querySelectorAll('.brt-qa-opt-group');
    var selOpts = [];
    groups.forEach(function (g) {
      var optIdx = parseInt(g.dataset.optIdx, 10);
      var sel = g.querySelector('.brt-qa-opt-btn.is-sel');
      if (sel) selOpts.push({ idx: optIdx, val: sel.dataset.val });
    });

    var variant = product.variants.find(function (v) {
      return selOpts.every(function (o) { return v.options[o.idx] === o.val; });
    }) || product.variants[0];

    var atcBtn = modal.querySelector('.brt-qa-atc');
    var priceEl = modal.querySelector('[data-price]');
    var imgEl = modal.querySelector('.brt-qa-img');
    if (variant) {
     atcBtn.dataset.variantId = variant.id;

    var isPreorder = modal.dataset.preorder === 'true';

    if (isPreorder) {
      atcBtn.disabled = false;
      atcBtn.textContent = 'Pre-order';
    } else {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      // Update image to match selected variant
      if (imgEl && variant.featured_image && variant.featured_image.src) {
        imgEl.src = variant.featured_image.src;
      }
    }
  }

  // ── Main click handler (capture phase — runs before the <a> sees the click) ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    var variantsCount = parseInt(btn.dataset.variantsCount || '1', 10);
    var productHandle = btn.dataset.productHandle;
    var isPreorder = btn.dataset.preorder === 'true';

       if (variantsCount <= 1) {
      // Single variant — add directly, show toast
      var labelEl = btn.querySelector('.brt-quick-add-label');
      var setLabel = function (text) {
        if (labelEl) {
          labelEl.textContent = text;
        } else {
          btn.textContent = text;
        }
      };
      var origLabel = labelEl ? labelEl.textContent : btn.textContent;

      setLabel('…');
      btn.disabled = true;
     addToCart(variantId, 1, function (err, item) {
        setLabel(origLabel);
        btn.disabled = false;
        if (!err && item) showToast(item);
      }, isPreorder);
    } else {
      // Multi-variant — fetch product JSON then open picker
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) { openModal(product, isPreorder); })
        .catch(function () {
          // Fallback: navigate to product page
          window.location.href = btn.dataset.productUrl || btn.closest('a') && btn.closest('a').href || '#';
        });
    }
  }, true); // <-- capture phase: fires BEFORE the <a> parent sees the event

})();